import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import RankingPage from "../pages/ranking/page";
import BreakingPage from "../pages/breaking/page";
import CategoryPage from "../pages/category/page";
import TopicPage from "../pages/topic/page";
import AboutPage from "../pages/about/page";
import ContactPage from "../pages/contact/page";
import SiteLayout from "../components/feature/SiteLayout";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <SiteLayout />,
    children: [
      {
        index: true,
        element: <Home />,
      },
      {
        path: "ranking",
        element: <RankingPage />,
      },
      {
        path: "breaking",
        element: <BreakingPage />,
      },
      {
        path: "category/:slug",
        element: <CategoryPage />,
      },
      {
        path: "topic/:slug",
        element: <TopicPage />,
      },
      {
        path: "about",
        element: <AboutPage />,
      },
      {
        path: "contact",
        element: <ContactPage />,
      },
      {
        path: "*",
        element: <NotFound />,
      },
    ],
  },
];

export default routes;